import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotificationsOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"notifications_off"}/>
}
